import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class ConsolidationLedgersService {

  constructor(private http: HttpClient) { }

  saveConsLedgers(
    baseUrl: string,
    clobSettings: any,
    ledgersFormSaveDtls: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // Build payload EXACTLY like original AngularJS with proper fallbacks
    let params = _.merge({}, globalService || {}, filterParams);
    
    // Essential parameters with fallbacks
    params.clob_settings = JSON.stringify(clobSettings);
    params.clob_data = JSON.stringify(ledgersFormSaveDtls);
    params.tax_year = filterParams.tax_year || params.tax_year;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || 250; // AngularJS factory fallback
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";
    
    // Add process name
    params.process_name = "SAVE_CONSOL_LEDGER_CATG";
    
    // 🔴 MUST use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    
    const url = baseUrl + '/saveJsonObject?action_code=fe5q9h';
    
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
